<template>
  <div class="main-content">
    <div class="head-navigate">
      <a-icon
        type="left"
        :style="{ fontSize: '20px', color: '#333' }"
        @click="backPage"
      />
      <span>累计欠数</span>
    </div>
    <!-- 搜索框 -->
    <div class="search-content">
        <van-search
            v-model="searchValue"
            show-action
            placeholder="请输入搜索关键词"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
    </div>
    <!-- 菜单条件筛选部分 -->
    <div class="menu-select">
      <div @click="areaShow=true">
        <span>{{allAreaSelect}}</span>
        <a-icon type="down" style="" />
      </div>
      <div @click="rankShow=true">
        <span>{{rankSelectText}}</span>
        <a-icon type="down" />
      </div>
    </div>
    <!-- 列表部分 -->
    <div class="data-list">
        <div class="list-head">
            <div class="td">序号</div>
            <div class="td">租户名称</div>
            <div class="td">租赁面积（m²）</div>
            <div class="td">累计欠数</div>
        </div>
        <div class="list-body" v-for="(item,index) in shouldData.list" :key="index">
            <div class="td"><span :style="{'background-color': index<5?'#FF5215':'#B3C5D1'}">{{(index+1)>=10?index+1:'0'+(index+1)}}</span></div>
            <!-- <div class="td"><span>01</span></div> -->
            <div class="td">{{item.name}}</div>
            <div class="td">{{item.rent_room_area}}</div>
            <div class="td">{{(item.overdraft/10000).toFixed(2)}}</div>
        </div>
    </div>
    <!-- 区域选择 -->
    <van-action-sheet v-model="areaShow">
      <van-picker
        title="区域"
        show-toolbar
        value-key="name"
        :columns="areaActions"
        @confirm="areaSelect"
        @cancel="areaShow = false"
      />
    </van-action-sheet>
    <!-- 排序选择 -->
    <van-action-sheet v-model="rankShow">
      <van-picker
        title="排序"
        show-toolbar
        value-key="name"
        :columns="rankActions"
        @confirm="rankSelect"
        @cancel="rankShow = false"
      />
    </van-action-sheet>
  </div>
</template>
<script>
import { billsShould,areaList } from "../axios/property";
export default {
  components: {},
  data() {
    return {
      companyId: "",
      searchValue: '',
      shouldForm: { // 账单应收表单数据
        rentAreaId: '',
        searchName: ''
      },
      allAreaSelect: '全部',
      rankSelectText: '排序',
      areaShow: false,
      rankShow: false,
      areaActions: [{name:'全部'}],
      rankActions: [{name:'金额从高到低',value: 0},{name:'金额从低到高',value: 1}],
      shouldData: []
    };
  },
  created() {
    this.companyId = localStorage.getItem("companyId")
    this.getAreaList();
    this.getBillShould();
  },
  methods: {
    getAreaList(){ // 获取区域选择器option数据
      let that = this
      let data = {
        companyId: this.companyId,
      };
      areaList(data).then((res) => {
        console.log(res);
        if(res.data.code==0){
          for(let i=0;i<res.data.data.length;i++){
            that.areaActions.push(res.data.data[i])
          }
        }
      });
    },
    getBillShould(){ // 获取账单应收数据
      let that = this;
      this.shouldSalaryList = []
      let requestData = {
        comId: this.companyId,
        time: 1,
        ...this.shouldForm
      };
      billsShould(requestData).then(res=>{
        console.log(res)
        if(res.data.code==0){
            that.shouldData = res.data.data
            for(let i=0;i<that.shouldData.list.length;i++){
              that.shouldData.list[i].percent = ((that.shouldData.list[i].overdraft/that.shouldData.list[i].bill_figure).toFixed(2))*100
            }
        }
      })
    },
    areaSelect(value) {
      // 更改区域
      console.log(value);
      if(value.id){
        this.shouldForm.rentAreaId = value.id;
        this.allAreaSelect = value.name
      } else {
        this.shouldForm.rentAreaId = "";
        this.allAreaSelect = value.name
      }
      this.getBillShould();
      this.areaShow = false;
    },
    rankSelect(value){ // 更改排序
      console.log(value);
      this.shouldForm.orderBy = value.value;
      this.rankSelectText = value.name
      this.getBillShould();
      this.rankShow = false;
    },
    onSearch(value){
        console.log(value)
        console.log(this.searchValue)
        this.shouldForm.searchName = this.searchValue
        this.getBillShould()
    },
    backPage() {
      // 回退到app
      this.$router.push("/property-Board");
    },
  },
};
</script>
<style scoped>
.main-content {
  background-color: #f9f9f9;
}
.head-navigate {
  display: flex;
  align-items: center;
  background-color: white;
  padding: 0.3rem 0.3rem;
  border-bottom: 1px solid #f0f2f5;
}
.head-navigate span {
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  color: #333333;
  margin: auto;
}
/* 菜单条件筛选部分 */
.menu-select {
  display: flex;
  align-items: center;
  background-color: white;
  justify-content: space-around;
  height: 1.3rem;
}
.menu-select > div {
  display: flex;
  width: 45%;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #939496;
}
.menu-select > div > span {
  margin-right: 0.1rem;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.menu-select > div:nth-child(1) {
  margin-left: 0.5rem;
}

.menu-select > div:nth-child(2) {
  margin-right: 0.5rem;
}
/* 列表部分 */
.data-list{
  background-color: white;
  margin-top: 0.2rem;
  padding: 0.3rem;
}
.data-list .list-head{
    display: flex;
    align-items: center;
}
.list-head .td{
    font-size: 0.4rem;
    font-weight: 400;
    color: #808080;
}
.list-head .td:nth-child(1){
    width: 18%;
}
.list-head .td:nth-child(2){
    width: 30%;
}
.list-head .td:nth-child(3){
    width: 35%;
    margin-right: auto;
}
.data-list .list-body{
    display: flex;
    align-items: center;
    margin-top: 0.3rem;
}
.list-body .td{
    font-size: 0.4rem;
    font-weight: 400;
    color: #333333;
}
.list-body .td:nth-child(1){
    width: 18%;
}
.list-body .td:nth-child(1) span{
    color: white;
    background: #B3C5D1;
    border-radius: 4px;
    padding: 2px 5px;
    margin: 0 auto;
    text-align: center;
}
.list-body .td:nth-child(2){
    width: 30%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.list-body .td:nth-child(3){
    width: 35%;
    margin-right: auto;
    text-indent: 1.5em;
}
</style>
